import React, { useState } from "react";
import './HeaderBar.css';
import {Link} from 'react-router-dom';
import colorfuelIcon from '../../../assets/colorfuel-cropped-logo.png';
import { WalletButton, WalletPanel } from "../../wallet";
import { useAppKitAccount } from "@reown/appkit/react";
//import ShoppingSideMenu from "../../shopping/ShoppingSideMenu";
//import { useCart } from '../../shopping/cart/CartContext';

const HeaderBar = () => {
    const [isWalletOpen, setIsWalletOpen] = useState(false);
    //const [isShoppingMenuOpen, setIsShoppingMenuOpen] = useState(false);
    const { address, isConnected } = useAppKitAccount();
    //const { cart } = useCart();

    // Calculate total quantity in cart
    //const totalQty = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);

    const toggleWallet = () => {
      setIsWalletOpen(!isWalletOpen);
    };

    const closeWallet = () => {
      setIsWalletOpen(false);
    };

    /*const openShoppingMenu = () => {
      setIsShoppingMenuOpen(true);
    };
    const closeShoppingMenu = () => {
      setIsShoppingMenuOpen(false);
    };*/

    return (
      <>
      <header className="header">
        <div className="header-container">
          <Link className="logo-link" to="/">
            <img className="logo-icon" src={colorfuelIcon} alt="ColorFuel Logo" />
            <span className="logo-text">ColorFuel</span>
          </Link>

          <nav className="header-nav">
            <Link className="nav-link" to="/create">Create</Link>
            <Link className="nav-link" to="/discover">Discover</Link>
            <Link className="nav-link" to="/3dgallery">Simulation</Link>
            <Link className="nav-link" to="/about">About</Link>
          </nav>

          <div className="header-actions">
            <WalletButton
              onClick={toggleWallet} 
              isConnected={isConnected} 
              walletAddress={address}
            />
          </div>
        </div>
      </header>

      {/* Wallet Panel */}
      <WalletPanel isOpen={isWalletOpen} onClose={closeWallet} />
      </>
    );
}

export default HeaderBar;